import React from 'react'

const AdminFooter = () => {
  return (
    <div>
        <div className="adminfooter">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <p>
                        © Copyright 2025 Metier Media. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AdminFooter